import { useState } from "react";
import { useDispatch } from "react-redux";

import { lockUnlockProcoDocuments } from "../../../../../../lib/fetchApi";
import Button from "../../../../../common/Button";
import { notificationActions } from "../../../../../../store/notifications";
import { caseActions } from "../../../../../../store/case";

import classes from './Controls.module.css'

export default function LockUnlockDocument({userToken, activeCase, item}) {
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false)

    async function lockUnlockHandler() {
        setLoading(true)
        try {
            let reqBody = {
                is_ecm_locked: item.is_ecm_locked ? 0 : 1
            }

            let update = await lockUnlockProcoDocuments(userToken, activeCase.case.id, item.id, reqBody)

            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))            
            } else {
                // /success 
                
                // add item to store dispatch
                dispatch(caseActions.replaceItemInProcoDocuments(update))
            }
        } finally {
            setLoading(false)
        }
    }
    return <Button title={item.is_ecm_locked ? 'Unlock Document' : 'Lock Document'} btnStyle={'btn_simple'} click={lockUnlockHandler} isLoading={loading} loaderType={'dark'}>
        <div className={item.is_ecm_locked ? classes.locked : ''}><i className="ti ti-lock"></i></div>
    </Button>
}